module.exports = __webpack_public_path__ + "static/media/sound.332ee567.svg";